<template>
    <div>
        <common-table :table-columns="tableColumns" :url="url" :operate="[]" :form-fields="formFields" :permission="permission" :searchs="searchs" ref="table"/>
    </div>
</template>

<script>
    import CommonTable from "../../components/CommonTable/CommonTable";
    export default {
        name: "FirstRechargeActivity",
        components: {CommonTable},
        data() {
            return {
                searchs:[
                    {
                        name: 'agentId',
                        placeholder: '代理',
                        type: 'select',
                        selectUrl: '/agent/getAll',
                        selectData: [],
                    },
                    {
                        name: 'type',
                        placeholder: '请选择类型',
                        type: 'select',
                        selectValue:[{
                            key: 1,
                            value: '充值到基础钱包'
                        },{
                            key: 2,
                            value: '充值到促销钱包'
                        }]
                    }
                ],
                permission:{
                    add: 'firstRechargeActivity:add',
                    update: 'firstRechargeActivity:update',
                    delete: 'firstRechargeActivity:delete',
                    deleteBatch: 'firstRechargeActivity:deleteBatch'
                },
                url: {
                    get: '/firstRechargeActivity/listByCondition',
                    add: '/firstRechargeActivity/add',
                    update: '/firstRechargeActivity/update',
                    delete: '/firstRechargeActivity/delete',
                    delete_batch: '/firstRechargeActivity/deleteBatch'
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '75',
                }, {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    show: {
                        type: 'select',
                    },
                    detail: false,
                    width: '',
                }, {
                    field: 'type',
                    label: '类型',
                    show: {
                        type: 'select'
                    },
                    selectData: [
                        {
                            id: 1,
                            name: '充值到基础钱包',
                        },{
                            id: 2,
                            name: '充值到促销钱包',
                        }
                    ],
                }, {
                    field: 'minAmount',
                    label: '最低充值',
                    show: true,
                }, {
                    field: 'maxAmount',
                    label: '最高充值',
                    show: true,
                }, {
                  field: 'wallet',
                  label: '钱包赠送类型',
                  show: {
                    type: 'select'
                  },
                  selectData: [
                    {
                      id: 1,
                      name: '赠送到基础钱包',
                    },{
                      id: 2,
                      name: '赠送到促销钱包',
                    }
                  ],
                },{
                    field: 'deposit',
                    label: '赠送额度',
                    show: true,
                },{
                  field: 'superDeposit',
                  label: '上级赠送额度',
                  show: true,
                }],
                formFields: {
                    addTitle: '添加首充活动',
                    updateTitle: '修改首充活动',
                    labelWidth: '90px',
                    model: [{
                        field: 'agentId',
                        label: '代理：',
                        type: 'select',
                        placeholder: '请选择代理',
                        rules:[{required: true, message: '请选择代理', trigger: 'blur'}],
                        selectUrl: '/agent/getAll',
                        selectData: [],
                        add: true,
                        update: true,
                        filterable: true,
                    }, {
                        field: 'type',
                        label: '类型',
                        type: 'select',
                        selectData: [{
                            id: 1,
                            name: '充值到基础钱包',
                        }, {
                            id: 2,
                            name: '充值到促销钱包',
                        }],
                        placeholder: '请选择',
                        rules: [{
                            message: '请选择', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: false,
                    }, {
                        field: 'minAmount',
                        label: '最低充值：',
                        type: 'input',
                        placeholder: '最低充值金额',
                        rules:[{
                            message: '请输入最低充值金额', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true
                    }, {
                        field: 'maxAmount',
                        label: '最高充值：',
                        type: 'input',
                        placeholder: '最高充值金额',
                        rules:[{
                            message: '请输入最高充值金额', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true
                    }, {
                      field: 'wallet',
                      label: '赠送钱包类型：',
                      type: 'select',
                      selectData: [{
                        id: 1,
                        name: '赠送到基础钱包',
                      }, {
                        id: 2,
                        name: '赠送到促销钱包',
                      }],
                      placeholder: '请选择',
                      rules: [{
                        message: '请选择', trigger: 'blur', required: true
                      }],
                      add: true,
                      update: true,
                    },{
                        field: 'deposit',
                        label: '赠送额度：',
                        type: 'input',
                        placeholder: '赠送额度',
                        rules:[{
                            message: '请输入赠送额度', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true
                    },{
                      field: 'superDeposit',
                      label: '上级赠送额度：',
                      type: 'input',
                      placeholder: '上级赠送额度',
                      rules:[{
                        message: '请输入上级赠送额度', trigger: 'blur', required: true
                      }],
                      add: true,
                      update: true
                    }]
                }
            }
        },
    }
</script>

<style scoped>

</style>
